import React from 'react'
import "./testimonial.css"
import { FaStar } from "react-icons/fa";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Testimonial() {
    var testSettings = {
        arrows: false,
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <>
            <div className='testimonialmaindiv'>
                <div className='testheadingdiv'>
                    <h2>Customer Experiences</h2>
                    <div className='testline'></div>
                </div>


                <div id='testslider' className='testslider'>
                    <Slider {...testSettings}>
                        <div className='testslidermaindiv'>
                            <div className='testslidermaindivinner'>
                                <p>
                                    I ordered my wedding invitations from Patrika , and I'm beyond impressed! The selection was great, and customization options were easy to use. The quality of the cards is top-notch, with vibrant colors and luxurious paper. Customer service was helpful and responsive. Shipping was quick, and the invitations arrived in perfect condition. I've received so many compliments on how beautiful they are. Highly recommend!</p>
                                <h4>-Zarir Gandhi</h4>
                                <div className='testratingstar'><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /></div>
                            </div>
                        </div>
                        <div className='testslidermaindiv'>
                            <div className='testslidermaindivinner'>
                                <p>
                                "We are so grateful to Patrika for creating our stunning wedding invitations! From the moment we contacted them, the team was attentive and professional, helping us choose a design that perfectly blended tradition and elegance. The customization options were amazing, and the quality of the paper and printing was exceptional. Our guests were absolutely wowed by the vibrant colors and intricate details of the invites. Patrika delivered on time, making the entire process smooth and stress-free. We couldn’t be happier with the results and highly recommend them for anyone looking for beautiful, high-quality wedding stationery!"</p>
                                <h4>-Zarir Gandhi</h4>
                                <div className='testratingstar'><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /></div>
                            </div>
                        </div>
                        <div className='testslidermaindiv'>
                            <div className='testslidermaindivinner'>
                                <p>"Our experience with Patrika for our wedding invitations was truly exceptional! From the moment we started, their team was attentive and creative, helping us design the perfect invitations to reflect our style and heritage. The variety of designs they offered was impressive, and they worked closely with us to create something unique. The quality of the printing and paper was outstanding, making the invitations feel elegant and luxurious. We received endless compliments from our guests about how beautiful and intricate the invites were. Patrika made the whole process seamless and delivered everything right on schedule. We highly recommend their services for anyone seeking premium, beautifully crafted wedding invitations."
                                </p>
                                <h4>-Zarir Gandhi</h4>
                                <div className='testratingstar'><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /></div>
                            </div>
                        </div>
                        <div className='testslidermaindiv'>
                            <div className='testslidermaindivinner'>
                                <p>
                                "We had an amazing experience working with Patrika for our wedding invitations! From start to finish, their team was incredibly professional, patient, and helpful in bringing our vision to life. The range of designs was fantastic, and they offered great customization options to match our theme perfectly. The quality of the paper, printing, and overall craftsmanship was superb, and we received so many compliments from our guests about how unique and beautiful the invitations were. The process was seamless, and everything was delivered on time. Patrika truly made our wedding invites a standout feature of our celebration. Highly recommend their services!"</p>
                                <h4>-Zarir Gandhi</h4>
                                <div className='testratingstar'><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /><FaStar size={25} color='#d4af35' /></div>
                            </div>
                        </div>
                        
                        
                        
                    </Slider>
                </div>
            </div>
        </>

    )
}

export default Testimonial
